
import {enableProdMode, LOCALE_ID} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {MAT_DATE_LOCALE} from "@angular/material/core";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
    providers: [
        {provide: LOCALE_ID, useValue: 'ro' },
        {provide: MAT_DATE_LOCALE, useValue: 'ro'},
    ]
})
  .catch(err => console.error(err));
